<template lang="pug">
	.input-v4(:class="{'with-search-icon': searchIcon, 'error': error, 'focus-interaction': focusInteraction && !error}")
		.label-container
			label(v-if="label.trim() != ''" :for="id")
				| {{label}}
			slot(name="tooltip")
		img.search-icon(v-if="searchIcon" :src="`${$store.state.config.s3ResourceHost}/images/icon-search.svg`")
		money(v-if="type == 'money'" :id="id" :value="value" v-bind="moneyFormat" @input="emitInputMoney" @change="emitChange($event)" @keyup.native.enter="emitKeyup($event)" :name="name" :aria-labelledby="labelledBy" @focus="onFocus" :autocomplete="autocomplete")
		input(v-else-if="type=='number'" :id="id" type="number" min="minimum" max="maximum" :value="value" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" @focus="onFocus" :name="name" :aria-labelledby="labelledBy" :autocomplete="autocomplete")
		input(v-else-if="type=='password'" :id="id" type="password" :value="value" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" :autocomplete="autocomplete" @focus="onFocus" :name="name" :aria-labelledby="labelledBy")
		textarea(v-else-if="type == 'textarea'" :id="id" type="password" :value="value" @change="emitChange($event)" @focus="onFocus" @blur="onBlur" @input="emitInput($event)" :placeholder="placeholder" autocomplete="new-password" ref="input" :aria-labelledby="labelledBy")
		input(v-else :id="id" type="text" :value="value" @click="emitClick($event)" @change="emitChange($event)" @input="emitInput($event)" @keyup.native.enter="emitKeyup($event)" :placeholder="placeholder" @keypress="emitKeypress($event)" :inputmode="inputmode" :autocomplete="autocomplete" @focus="onFocus" :name="name" @blur="onBlur" :aria-labelledby="labelledBy")
		.error-message(v-if="error")
			| {{errorMessage}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

	.input-v4
		position: relative
		label
			width: 100%
			font-size: body-font-size-md
			font-weight: body-font-weight-strong
			line-height: normal
			padding: 0
			margin-bottom: 8px
			text-align: left
			box-sizing: border-box
		&.error
			input
			textarea
				border: 1px solid error
				&:focus
					error-box-shadow()
					border: 1px solid error
		&.focus-interaction
			input
			textarea
				&:focus
					border: 1px solid blue-primary !important
		input
		textarea
			width: 100%
			padding: 6px 8px
			border: 1px solid gray-40
			font-size: body-font-size
			line-height: body-font-line-height
			border-radius()
			background-color: #fff
			&::-webkit-input-placeholder
				color: gray-40
				opacity: 1
			&::-moz-placeholder
				color: gray-40
				opacity: 1
			&:-ms-input-placeholder
				color: gray-40
				opacity: 1
			&:-moz-placeholder
				color: gray-40
				opacity: 1
			&::placeholder
				color: gray-40
				opacity: 1

		input[type="number"]::-webkit-outer-spin-button
		input[type="number"]::-webkit-inner-spin-button
			-webkit-appearance: none
			margin: 0
		input[type="number"]
			-moz-appearance: textfield

		.error-message
			font-size: body-font-size-xs
			color: error

		&.with-search-icon
			input
				padding-left: 45px !important

		.search-icon
			position: absolute
			top: 15px
			left: 15px
</style>
<script>
import {Money} from 'v-money'
export default {
	props: {
		value:{

		},
		errorMessage:{
			default: ""
		},
		error:{
			default: false
		},
		type:{

		},
		label:{
			default: ""
		},
		placeholder:{

		},
		searchIcon:{
			default: false
		},
		precision:{
			default: 0
		},
		prefix:{
			default: "$"
		},
		suffix:{
			default: ""
		},
		min:{

		},
		max:{

		},
		inputmode:{
			default: "text"
		},
		autocomplete: {
			default: "true"
		},
		scrollOnFocus: {
			default: false
		},
		scrollContainer: {
			default: undefined
		},
		name: {
			default: ""
		},
		labelledBy: {
			default: undefined
		},
		focusInteraction: {
			default: undefined
		}
	},
	components: {Money},
	data() {
		return {
			minimum: this.$props.min || -999999999999,
			maximum: this.$props.max || 999999999999,
			vmodel: "",
			id: undefined,
			moneyFormat:{
				decimal: '.',
				thousands: ',',
				prefix: this.$props.prefix == "none" ? "" : this.$props.prefix,
				suffix: this.$props.suffix,
				precision: this.$props.precision,
				masked: false /* doesn't work with directive */
			},
			lastValueSent: undefined
		}
	},
	mounted(){
		let randomNumber = Math.ceil(Math.random()*1000000)
		this.id = `sfc-input-v3-${randomNumber}`
	},
	methods: {
		emitClick(event) {
			this.$emit('click', event)
		},
		emitChange(event) {
			this.$emit('change', event)
		},
		emitInput(event) {
			this.$emit('input', event.target.value)
		},
		emitKeyup(event) {
			this.$emit('keyup', event.target.value)
		},
		emitKeypress(event) {
			this.$emit('keypress', event.target.value)
		},
		emitInputMoney(value) {
			if(value == this.lastValueSent){
				return
			}else{
				this.lastValueSent = value
				this.$emit('input', value)
			}
		},
		onFocus(event){
			this.$emit('focus')
			if(!this.scrollOnFocus || !this.scrollContainer) return
			setTimeout(() => {
				document.querySelector(this.scrollContainer).scrollTop += event.target.getBoundingClientRect().top-20
			}, 300)
		},
		onBlur(event){
			this.$emit('blur')
		}
	}
}
</script>
